import { render } from "./ScenariosMaker.vue?vue&type=template&id=1ba1a5b2&scoped=true"
import script from "./ScenariosMaker.vue?vue&type=script&lang=ts"
export * from "./ScenariosMaker.vue?vue&type=script&lang=ts"

import "./ScenariosMaker.vue?vue&type=style&index=0&id=1ba1a5b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ba1a5b2"

export default script